import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-radar',
  templateUrl: './radar.component.html',
  styleUrl: './radar.component.css',
  standalone: false,
})
export class RadarComponent implements OnInit {
  @Input() radarImageUrl: string = '';

  currentDisplayImageUrl: string = '';
  constructor() {

  }
  ngOnInit(): void {

    this.selectRadarType('PPI');
  }

  selectRadarType(type: string): void {
    if (!this.radarImageUrl) {
      console.warn('Base radar image URL is not available to select type.');
      return;
    }

    let imageUrl = '';

    if (!this.radarImageUrl) {
      console.error('Could not determine radar station code from radarImageUrl:', this.radarImageUrl);
      return;
    }

    switch (type) {
      case 'PPI':
        imageUrl = `${this.radarImageUrl}ppi15.jpg`;
        break;
      case 'MAKS':
        imageUrl = `${this.radarImageUrl}max15.jpg`;
        break;
      case 'VIL':
        imageUrl = `${this.radarImageUrl}vil15.jpg`;
        break;
      case 'RUZGAR':
        imageUrl = `${this.radarImageUrl}rzg15.jpg`;
        break;
      default:
        console.warn('Unknown radar type selected:', type);
        imageUrl = `${this.radarImageUrl}ppi15.jpg`;
        break;
    }

     this.currentDisplayImageUrl = imageUrl;

  }

}
